"use strict";

// Copyright 2017-2020 The MathWorks, Inc.
define([], function () {
  'use strict';
  /**
    * @typedef widgetDefinition
    * @property {string} name Registered name of the widget.  Used
    * by the browser when intantiating a widget via HTML or
    * document.createElement.  Needs to be a  kebab-case string starting
    * with "mw-" e.g. mw-some-widget
    * @property {instanceOf} widgetClass the class used as
    * the widget class.  Should extend from WidgetBase
    */

  /**
     * Defines a Widget, registers the widget with
     * the browser, and returns a factory that can be
     * used to instantiate a widget programmatically.
     * @param {widgetDefinition} widgetDefinition
     * @returns CreateWidgetFunction
     */

  let defineWidget = function (widgetDefinition) {
    if (!widgetDefinition.widgetClass) {
      throw new Error('The widgetClass object must have a widget widgetClass property');
    }

    if (!widgetDefinition.name) {
      throw new Error('The widgetDefinition object must have a name property');
    }

    if (widgetDefinition.name.length < 3 || widgetDefinition.name.substring(0, 3) !== 'mw-') {
      throw new Error('The widgetDefinition object must have a name' + "property starting with 'mw-'");
    }

    let WidgetClass = widgetDefinition.widgetClass;

    if (WidgetClass._observedAttributes) {
      // Copy _observedAttributes from
      // Widget widgetClass to avoid accidental mutation
      // at runtime.  Then define the
      // observedAttributes static getter
      // Backwards compatability with original WidgetBase API
      let observedAttributes = WidgetClass._observedAttributes.slice(0);

      Object.defineProperty(WidgetClass, 'observedAttributes', {
        enumerable: false,
        get: function get() {
          return observedAttributes;
        }
      });
    }

    customElements.define(widgetDefinition.name, WidgetClass); // Return a function that applies parameters to an instance of
    // the Widget

    return function create(params) {
      if (this instanceof create) {
        throw new Error("Do not use 'w = new Widget()' to create a widget instance. " + "Just use 'w = Widget()'");
      }

      let widget = new WidgetClass();

      for (let prop in params) {
        if (Object.prototype.hasOwnProperty.call(params, prop)) {
          widget[prop] = params[prop];
        }
      }

      return widget;
    };
  };

  return defineWidget;
});
//# sourceMappingURL=defineWidget.js.map
